import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { makePostRequest } from 'utils/api'
import { convertToMuiDate } from 'utils/helpers'
import urls from 'utils/urls'
import { Box, Checkbox, FormControlLabel, FormGroup, useMediaQuery, useTheme, TextField, CircularProgress, Alert } from '@mui/material'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'

export default function AddListeCourse({ data }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = useState(false)
  const [selected, setSelected] = useState([])
  const [recette, setRecette] = useState([])
  const [listName, setListName] = useState('')
  const [creating, setCreating] = useState(false)
  const [error, setError] = useState('')

  const { handleSubmit, reset } = useForm({
    defaultValues: {},
  })
  useEffect(() => {}, [])

  const handleClose = () => {
    setOpen(false)
    setListName('')
    setError('')
    reset()
  }
  const handleChange = (id) => {
    if (selected.includes(id)) {
      setSelected(selected.filter((e) => e !== id))
    } else {
      setSelected([...selected, id])
    }
  }
  const handleOpen = () => {
    console.log(data)
    let ss = []
    setRecette(
      data.filter((e) => {
        let d = convertToMuiDate(e.Date)
        let edate = new Date(d)
        let today = new Date()

        if (edate > today) {
          if (!ss.includes(e.id)) {
            ss.push(e.id)
          }
          return e
        }
        return null
      }),
    )
    setSelected(ss)
    setOpen(true)
    reset()
  }

  const onSubmit = async (formData) => {
    if (!selected.length > 0) {
      setError('Veuillez sélectionner au moins une recette')
      return
    }

    setCreating(true)
    setError('')

    try {
      // Step 1: Get ingredients from selected recipes
      const ingredientsPayload = { selected }
      const ingredientsResponse = await makePostRequest(urls.getIngredients, ingredientsPayload, {}, true)
      
      if (ingredientsResponse.status !== 200) {
        throw new Error('Erreur lors de la récupération des ingrédients')
      }

      const ingredients = ingredientsResponse.data

      // Step 2: Create shopping list with ingredients
      const selectedRecipeNames = recette
        .filter(r => selected.includes(r.id))
        .map(r => r.RecetteNom)
        .join(', ')

      const defaultListName = `Liste de course du ${new Date().toLocaleDateString()}`
      const finalListName = listName.trim() || defaultListName

      // Prepare ingredients data for shopping list
      const selectedIngredientsData = ingredients.map(ing => ({
        name: ing.NomIngredient || ing.name,
        quantity: ing.Quantite || ing.quantity || 1,
        unit: ing.um?.Designation || ing.um?.UM || ing.unit || 'pcs',
        notes: `Recettes: ${selectedRecipeNames}`,
      }))

      const shoppingListPayload = {
        recipe_ids: selected,
        selected_ingredients: selectedIngredientsData,
        list_name: finalListName,
      }

      const shoppingListResponse = await makePostRequest(
        `${urls.shoppingLists}create_from_recipes/`,
        shoppingListPayload,
        {},
        true
      )

      if (shoppingListResponse.status === 201) {
        // Success - close dialog and show success message
        handleClose()
        // You can add a success notification here if you have a notification system
        alert(`Liste de courses "${finalListName}" créée avec succès avec ${selectedIngredientsData.length} ingrédients!`)
      } else {
        throw new Error('Erreur lors de la création de la liste de courses')
      }
    } catch (error) {
      console.error('Error creating shopping list:', error)
      setError(error.message || 'Erreur lors de la création de la liste de courses')
    } finally {
      setCreating(false)
    }
  }

  return (
    <>
      {isMobile ? (
        <AddShoppingCartIcon onClick={handleOpen} />
      ) : (
        <Button
          variant="outlined"
          startIcon={<AddShoppingCartIcon />}
          onClick={handleOpen}
          sx={{
            borderRadius: 999,
            textTransform: 'none',
            fontWeight: 850,
            px: 1.8,
            color: '#ffffff',
            borderColor: 'rgba(255,255,255,0.22)',
            '&:hover': { borderColor: 'rgba(255,255,255,0.5)', bgcolor: 'rgba(255,255,255,0.08)' },
          }}
        >
          Ajouter à la liste de courses
        </Button>
      )}
      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <Box sx={{ color: 'black !important', fontWeight: 700, px: 5, pt: 3 }}>
          Créer une liste de courses depuis vos recettes
        </Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <TextField
              fullWidth
              label="Nom de la Liste (Optionnel)"
              value={listName}
              onChange={(e) => setListName(e.target.value)}
              placeholder={`Liste de course du ${new Date().toLocaleDateString()}`}
              helperText="Laissez vide pour générer automatiquement un nom avec la date d'aujourd'hui"
              sx={{ mb: 3 }}
              disabled={creating}
            />

            <Box sx={{ color: 'black !important', fontWeight: 600, mb: 2 }}>
              Déselectionner les recettes que vous ne souhaitez pas ajouter à votre liste de course
            </Box>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <FormGroup>
              {recette.map((r) => (
                <FormControlLabel
                  key={r.id}
                  control={
                    <Checkbox 
                      onClick={() => handleChange(r.id)} 
                      defaultChecked 
                      disabled={creating}
                    />
                  }
                  label={r.RecetteNom}
                  name="recette"
                />
              ))}
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} disabled={creating}>
              Annuler
            </Button>
            <Button 
              type="submit" 
              variant="contained"
              disabled={creating}
              startIcon={creating ? <CircularProgress size={20} /> : null}
            >
              {creating ? 'Création en cours...' : 'Créer la Liste'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
